import { ISystemActiveIngredientPharmaceuticalForm } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetActiveIngredientPharmaceuticalFormsQuery<
  D extends ISystemActiveIngredientPharmaceuticalForm[]
>(params?: HydraQueryParams<D>) {
  const { vars, options } = params || {};
  return useHydraQuery<D>(
    'getActiveIngredientPharmaceuticalForms',
    '/api/active_ingredient_pharmaceutical_forms',
    {
      vars,
      options,
    }
  );
}
